import React from "react";
import "./TableSkeleton.css";

const TableSkeleton = ({ rows = 5 }) => {
  return (
    <div className="table-responsive rounded-3">
      <table className="table table-hover align-middle bg-white border px-3 mb-3">
        <thead className="table-light">
          <tr>
            <th>Image</th>
            <th>Product Code</th>
            <th>Product Name</th>
            <th>Category</th>
            <th>Carbon Footprint</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {Array.from({ length: rows }).map((_, index) => (
            <tr key={index}>
              <td>
                <div className="skeleton-image"></div>
              </td>
              <td>
                <div className="skeleton-text skeleton-text-medium"></div>
              </td>
              <td>
                <div className="skeleton-text skeleton-text-long"></div>
              </td>
              <td>
                <div className="skeleton-badge"></div>
              </td>
              <td>
                <div className="skeleton-badge"></div>
              </td>
              <td>
                <div className="skeleton-actions">
                  <div className="skeleton-button"></div>
                  <div className="skeleton-button"></div>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default TableSkeleton;

